// Automation settings — self-service global toggles (greenlight.automation_settings).
// Replaces the old env-var-only AUTO_APPROVE_SAFE configmap flag (BOT-374/decision:
// selfserve). Distinct from queue.ts's job-queue pause control: this gates
// recompute_checks classification behavior, not gl_jobs claiming.

export const AUTO_APPROVE_SAFE_PRICES_KEY = 'auto_approve_safe_prices';
export const AUTO_APPROVE_NEW_ITEMS_KEY   = 'auto_approve_new_items';
/** BOT-411: global half of the Home Value auto-approve gate (AND'd with
 *  tbvendors.auto_approve_home_value, the per-vendor toggle on the Vendors page). */
export const AUTO_APPROVE_HOME_VALUE_KEY  = 'auto_approve_home_value';

export interface AutomationSetting {
  key: string;
  value: boolean;
  reason: string | null;
  updated_by_email: string | null;
  updated_at: string | null;
}

export async function fetchAutomationSettings(): Promise<AutomationSetting[]> {
  const res = await fetch('/api/v1/automation/settings', { credentials: 'include' });
  if (!res.ok) throw new Error(`Automation settings fetch failed: ${res.status}`);
  return res.json() as Promise<AutomationSetting[]>;
}

export async function setAutomationSetting(
  key: string,
  value: boolean,
  reason?: string | null,
): Promise<AutomationSetting> {
  const res = await fetch(`/api/v1/automation/settings/${encodeURIComponent(key)}`, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ value, reason: reason ?? null }),
  });
  if (!res.ok) {
    const detail = await res.text();
    throw new Error(`Update failed: ${res.status} ${detail}`);
  }
  return res.json() as Promise<AutomationSetting>;
}
